import { render, staticRenderFns } from "./FacebookShareSection.vue?vue&type=template&id=66f6bc2a&scoped=true&"
import script from "./FacebookShareSection.vue?vue&type=script&lang=js&"
export * from "./FacebookShareSection.vue?vue&type=script&lang=js&"
import style0 from "./FacebookShareSection.vue?vue&type=style&index=0&id=66f6bc2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66f6bc2a",
  null
  
)

export default component.exports